/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');
var opPaymantAccount = require('op-payment-account');
var paymentApi = require('./payment-api.service');
var loading = require('./loading.service');
var handleServiceError = require('./handle-error.service');
var operate = require('./operate.service').operate;
var iframeService = require('./iframe.service');
var domService = require('./dom.service');
var rootScope = require('./root-scope.service');
var liveValidation = require('op-payment-live-validation');
/**
 * Adds live validation to the form elements.
 */
function addLiveValidation() {
    liveValidation.addLiveValidation(rootScope, paymentApi, handleServiceError);
}

/**
 * Validates the form by posting the data to the validation URL.
 */
function validateForm() {
    var network = rootScope.getSelectedNetwork();
    var formElement = $(domService.getSelectedForm(network.networkCode));
    var formMap;

    if (network.links && network.links.iFrame) {
        iframeService.operate();
    } else {
        if (formElement.length) {
            formMap = formElement.find('input,select,textarea').serializeArray();
            var account = opPaymantAccount.fromForm(formMap);

            if (validateTOC(formElement)) {
                if (network.links.validation) {
                    paymentApi.validateAccount(network.links.validation, account, validateAccountCallback, account);
                } else {
                    operate(account);
                }
            } else {
                // TOC is not accepted, cancel submission
                loading.submitButtonNormal();
            }
        } else {
            // POST empty object for payment networks that don't have forms
            operate({});
        }
    }
}
/**
 * Checks whether required TOC flag is properly accepted by customer.
 *
 * @param form the account form element
 *
 * @return true if TOC is accepted or no required TOC element is located on the form,
 *         false if required TOC element is present but not accepted by customer.
 */
function validateTOC(form) {
    var optIn = form.find('input[name="optIn"]');
    var optInLabel;
    if (optIn.length && optIn.attr('required') && optIn.attr('required').length > 0) {
        // TOC is present (optIn with required attr)
        optInLabel = form.find('label[for="' + optIn.attr('id') + '"]');
        if (!optInLabel.length) {
            // if label is not found use parent to indicate color
            optInLabel = optIn.parent();
        }

        liveValidation.removeValidationCss(optInLabel);

        if (optIn.is(':checked')) {
            optInLabel.addClass('INFO');
            return true;
        } else {
            optInLabel.addClass('ERROR');
            return false;
        }
    } else {
        // there is no required TOC to accept
        return true;
    }
}
/**
 * Validate account callback method.
 *
 * @param data The data returned from the callback
 */
function validateAccountCallback(err, data, bindingAccount) {
    if (err) {
        return handleServiceError(err);
    }
    if (data.valid) {
        operate(bindingAccount);
    } else {
        var name, message, inputFields, messageField;
        var elementIdPrefix = '#' + rootScope.getSelectedNetworkCode() + 'form ';
        $(elementIdPrefix).addClass('has-validation-on-submit');
        for (name in data.messages) {
            messageField = $(elementIdPrefix + '[id$=' + name + '-message]');
            message = data.messages[name];

            if (!message || !messageField.length) {
                continue;
            }

            if (message.referredTo && message.referredTo.length) {
                // message for compound field
                inputFields = [];
                $.each(message.referredTo, function (index, refName) {
                    inputFields.push($(elementIdPrefix + '[id$=' + refName + ']'));
                });
            } else {
                // direct message
                inputFields = [$(elementIdPrefix + '[id$=' + name + ']')];
            }

            liveValidation.removeValidationCss(messageField);
            messageField.html('');

            $.each(inputFields, function (index, inputField) {
                // remove CSS decoration from field
                liveValidation.removeValidationCss(inputField.parent());
            });

            messageField.addClass(message.type);
            var messageFieldContent = message.message;
            messageField.html(messageFieldContent);
            $.each(inputFields, function (index, inputField) {
                inputField.parent().addClass(message.type);
                inputField.parents('.row').addClass(message.type + '-ROW');
            });
        }
        loading.submitButtonNormal();
    }
}

module.exports = {
    addLiveValidation: addLiveValidation,
    validateForm: validateForm,
};
